import { render } from "./BookTripPage.vue?vue&type=template&id=7afa44a1"
import script from "./BookTripPage.vue?vue&type=script&lang=js"
export * from "./BookTripPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__